(function(){
  "use strict";

  if (window.__PO_PILIERS_TRILANG_PROTECTED_20260401__) return;
  window.__PO_PILIERS_TRILANG_PROTECTED_20260401__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var STORAGE_KEY_LEGACY = "po_piliers_lang";
  var DEFAULT_LANG = "FR";
  var ROOT_SEL = ".po-axis-section[data-po-lex-id='piliers']";

  var URLS = {
    title: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Pilliers_posoenoiaux_2.png?v=1746290111",
    lexicon: "https://goodyart.store/pages/lexique-simplifie/",
    piliers: "https://goodyart.store/pages/piliers",
    rezonans: "https://goodyart.store/pages/rezonans",
    peroptissimisme: "https://goodyart.store/pages/peroptissimisme",
    illusion: "https://goodyart.store/pages/illusion",
    alioevolution: "https://goodyart.store/pages/alioevolution"
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(v){
    var s = clampStr(v).toUpperCase().trim().replace(/_/g, "-");
    if (s === "FR" || s.indexOf("FR") === 0) return "FR";
    if (s === "EN" || s.indexOf("EN") === 0) return "EN";
    if (s === "ES" || s.indexOf("ES") === 0) return "ES";
    return DEFAULT_LANG;
  }

  function htmlLangToUiLang(v){
    var s = clampStr(v).toLowerCase().trim().replace(/_/g, "-");
    if (s === "fr" || s.indexOf("fr") === 0) return "FR";
    if (s === "en" || s.indexOf("en") === 0) return "EN";
    if (s === "es" || s.indexOf("es") === 0) return "ES";
    return "";
  }

  function readLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_LEGACY) || ""; }catch(__e){ v = ""; }
    }
    if (v) return normLang(v);

    var dl = "";
    try{ dl = document.documentElement.getAttribute("lang") || ""; }catch(_ee){ dl = ""; }
    var mapped = htmlLangToUiLang(dl);
    return mapped || DEFAULT_LANG;
  }

  function storeLang(lang){
    var L = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, L); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, L); }catch(_e){}
    try{ localStorage.setItem(STORAGE_KEY_LEGACY, L); }catch(__e){}
    try{ document.documentElement.setAttribute("lang", L.toLowerCase()); }catch(___e){}
    return L;
  }

  function canon(txt){
    return '<span class="notranslate" translate="no" data-po-canon="1">' + clampStr(txt) + '</span>';
  }

  var CANON = {
    posoennoisme: "Posœnnoïsme",
    posoennoia: "Posœnnoïa",
    organon: "Organon posœnnoïal",
    rezonans: "RéZonans",
    peroptissimisme: "Péroptissimisme",
    illusion: "Illusion",
    alioevolution: "Aliœvolution",
    addition: "Addition synchrêtique",
    superposition: "Superposition de perspectives",
    instantane: "Instantané multiple",
    sujet: "Sujet pluriel",
    posoennoiaque: "Posœnnoïaque",
    posoennoique: "Posœnnoïque",
    modalites: "Modalités opératives",
    katupirsia: "Katûpirsia",
    axis: "Axis",
    title: "Piliers"
  };

  function buildBadge(label, img, alt, text){
    return (
      '<span class="po-pillars-badge">' +
        '<span class="po-pillars-badge__label">' + clampStr(label) + '</span>' +
        '<span class="po-pillars-badge__media" aria-hidden="true">' +
          '<img class="po-pillars-badge__img" src="' + clampStr(img) + '" alt="' + clampStr(alt) + '" loading="lazy" decoding="async" />' +
        '</span>' +
        '<span class="po-pillars-badge__text">' + clampStr(text) + '</span>' +
      '</span>'
    );
  }

  var LABELS = {
    FR: {
      guide: "Nombre-guide",
      element: "Élément",
      totem: "Totem",
      open: "déplier",
      see_page: "Voir la page",
      cta_translate: "Proposer une traduction du concept"
    },
    EN: {
      guide: "Guide-number",
      element: "Element",
      totem: "Totem",
      open: "expand",
      see_page: "Open page",
      cta_translate: "Suggest a translation for the concept"
    },
    ES: {
      guide: "Número-guía",
      element: "Elemento",
      totem: "Tótem",
      open: "desplegar",
      see_page: "Ver la página",
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  var DATA = {
    FR: {
      title: CANON.title,
      kicker: 'Extrait du <em>' + canon(CANON.katupirsia + ' 1 – ' + CANON.axis) + '</em><br />(Socle d’énergie de l’' + canon(CANON.organon) + ')',
      h_def: 'Définition opérative',
      def_short: canon(CANON.title) + ' forment le socle d’énergie agissant comme forces fondamentales et donnant impulsion, respiration, tension créatrice et faculté de déconstruction révélatrice.',
      def_long:
        '<p>Dans le ' + canon(CANON.posoennoisme) + ', les ' + canon(CANON.title) + ' constituent le socle mobile de l’' + canon(CANON.axis) + '. Ils stabilisent la transmission, orientent les rythmes de l’ensemble, injectent des tensions créatrices et initient le mouvement vers les Outils posœnnoïaux.</p>' +
        '<p>Leur fonction relève d’une dynamique de repères d’oscillations : ils demeurent stables sans rigidité, respirants sans dispersion. Chacun articule un élément, un totem, un nombre-guide, un idéogramme conceptuel et une représentation fonctionnelle.</p>' +
        '<p>' + canon(CANON.rezonans) + ' accorde ; ' + canon(CANON.peroptissimisme) + ' convertit la crise en relance ; ' + canon(CANON.illusion) + ' révèle et désenclave les filtres perceptifs ; ' + canon(CANON.alioevolution) + ' transforme par l’altérité en gardant l’ancrage. Ensemble, ils donnent au système sa tenue énergétique première.</p>',
      h_pillars: 'Les quatre piliers',
      h_features: 'Dynamiques opératives',
      features: [
        'Socle énergétique de l’Axis et repère d’oscillations de l’ensemble.',
        'Stabilisateurs de transmission et initiateurs du mouvement vers les Outils posœnnoïaux.',
        'Régulateurs rythmiques et vecteurs oscillatoires de l’Organon posœnnoïal.',
        'Chaque pilier articule un élément, un totem et un nombre-guide propres.',
        'Leur interaction avec les Engrenages nourrit l’émergence des Modalités opératives.'
      ],
      h_questions: 'Applications / repères',
      questions: [
        'Quel pilier doit être activé pour ajuster la situation présente ?',
        'La tension relève-t-elle d’un accordage, d’une traversée de crise, d’un filtre perceptif ou d’une altérité transformatrice ?',
        'Quel Outil posœnnoïal recevra le mieux l’impulsion du pilier activé ?',
        'Quel élément symbolique — Air, Feu, Eau, Terre — donne ici le régime le plus juste ?'
      ],
      example_title: 'Ex.',
      example: 'Une œuvre ou une décision peut demander d’abord l’accordage de ' + canon(CANON.rezonans) + ', puis la relance de ' + canon(CANON.peroptissimisme) + ', le dévoilement d’' + canon(CANON.illusion) + ', et enfin l’intégration d’' + canon(CANON.alioevolution) + ' pour devenir pleinement opérative.',
      h_family: 'Liens systémiques',
      family_1: '<p><strong>Avec les Outils :</strong> les ' + canon(CANON.title) + ' donnent le socle énergétique sur lequel ' + canon(CANON.addition) + ', ' + canon(CANON.superposition) + ', ' + canon(CANON.instantane) + ' et ' + canon(CANON.sujet) + ' peuvent se déployer avec cohérence.</p>',
      family_2: '<p><strong>Avec les Engrenages et les Modalités :</strong> les flux ' + canon(CANON.posoennoiaque) + ' et ' + canon(CANON.posoennoique) + ' agissent sur les ' + canon(CANON.title) + ', qui partagent alors leurs activités avec les Outils et nourrissent l’émergence des ' + canon(CANON.modalites) + '.</p>',
      h_wordbuild: 'Construction / logique du groupe',
      word_blocks: [
        { head: '1) Socle', text: 'Les Piliers servent de base dynamique : ils tiennent l’architecture sans l’immobiliser.' },
        { head: '2) Oscillation', text: 'Ils offrent des repères d’oscillations permettant à l’Organon de respirer entre tension, ajustement, dévoilement et transformation.' },
        { head: '3) Quadrature vivante', text: 'Air, Feu, Eau et Terre composent une distribution élémentaire où chaque pilier garde sa singularité tout en travaillant avec les autres.' }
      ],
      word_notes: [
        'Fonction posœnnoïale : « Socle » — repères d’oscillations.',
        'Nombres-guides : 22 / 11 / 6 / 4.',
        'Éléments : Air / Feu / Eau / Terre.',
        'Totems : Libellule / Phoenix / Sirène / Arbre.'
      ],
      cta_translate: LABELS.FR.cta_translate
    },
    EN: {
      title: CANON.title,
      kicker: 'Excerpt from <em>' + canon(CANON.katupirsia + ' 1 – ' + CANON.axis) + '</em><br />(Energy base of the ' + canon(CANON.organon) + ')',
      h_def: 'Operative definition',
      def_short: canon(CANON.title) + ' form the energy base acting as fundamental forces and generating impulse, breath, creative tension and revelatory deconstruction.',
      def_long:
        '<p>Within ' + canon(CANON.posoennoisme) + ', the ' + canon(CANON.title) + ' constitute the moving base of the ' + canon(CANON.axis) + '. They stabilize transmission, orient the rhythms of the whole, inject creative tensions and initiate movement toward the Posœnnoïal Tools.</p>' +
        '<p>Their function belongs to a logic of oscillation markers: stable without rigidity, breathing without dispersion. Each one articulates an element, a totem, a guide-number, a conceptual ideogram and a functional representation.</p>' +
        '<p>' + canon(CANON.rezonans) + ' tunes; ' + canon(CANON.peroptissimisme) + ' converts crisis into relaunch; ' + canon(CANON.illusion) + ' reveals and uncloisters perceptual filters; ' + canon(CANON.alioevolution) + ' transforms through alterity while preserving rootedness. Together, they give the system its primary energetic hold.</p>',
      h_pillars: 'The four pillars',
      h_features: 'Operative dynamics',
      features: [
        'Energy base of the Axis and oscillation markers for the whole.',
        'Transmission stabilizers and initiators of movement toward the Posœnnoïal Tools.',
        'Rhythmic regulators and oscillatory vectors of the Posœnnoïal Organon.',
        'Each pillar articulates its own element, totem and guide-number.',
        'Their interaction with the Gears nourishes the emergence of Operative Modalities.'
      ],
      h_questions: 'Applications / markers',
      questions: [
        'Which pillar should be activated to adjust the present situation?',
        'Does the tension concern tuning, crisis crossing, a perceptual filter, or transformative alterity?',
        'Which Posœnnoïal Tool will best receive the impulse of the activated pillar?',
        'Which symbolic element — Air, Fire, Water, Earth — offers the most fitting regime here?'
      ],
      example_title: 'Ex.',
      example: 'An artwork or a decision may first require the tuning of ' + canon(CANON.rezonans) + ', then the relaunch of ' + canon(CANON.peroptissimisme) + ', the unveiling work of ' + canon(CANON.illusion) + ', and finally the integration carried by ' + canon(CANON.alioevolution) + ' in order to become fully operative.',
      h_family: 'Systemic links',
      family_1: '<p><strong>With the Tools:</strong> the ' + canon(CANON.title) + ' provide the energetic base on which ' + canon(CANON.addition) + ', ' + canon(CANON.superposition) + ', ' + canon(CANON.instantane) + ' and ' + canon(CANON.sujet) + ' can unfold coherently.</p>',
      family_2: '<p><strong>With the Gears and Modalities:</strong> the ' + canon(CANON.posoennoiaque) + ' and ' + canon(CANON.posoennoique) + ' flows act upon the ' + canon(CANON.title) + ', which then share their activity with the Tools and nourish the emergence of ' + canon(CANON.modalites) + '.</p>',
      h_wordbuild: 'Construction / group logic',
      word_blocks: [
        { head: '1) Base', text: 'The Pillars serve as a dynamic foundation: they hold the architecture without immobilizing it.' },
        { head: '2) Oscillation', text: 'They provide oscillation markers allowing the Organon to breathe between tension, tuning, unveiling and transformation.' },
        { head: '3) Living quadrature', text: 'Air, Fire, Water and Earth compose an elemental distribution in which each pillar keeps its singularity while working with the others.' }
      ],
      word_notes: [
        'Posœnnoïal function: “Base” — oscillation markers.',
        'Guide-numbers: 22 / 11 / 6 / 4.',
        'Elements: Air / Fire / Water / Earth.',
        'Totems: Dragonfly / Phoenix / Siren / Tree.'
      ],
      cta_translate: LABELS.EN.cta_translate
    },
    ES: {
      title: CANON.title,
      kicker: 'Extracto de <em>' + canon(CANON.katupirsia + ' 1 – ' + CANON.axis) + '</em><br />(Zócalo energético del ' + canon(CANON.organon) + ')',
      h_def: 'Definición operativa',
      def_short: canon(CANON.title) + ' forman el zócalo de energía que actúa como fuerza fundamental y produce impulso, respiración, tensión creadora y deconstrucción reveladora.',
      def_long:
        '<p>En el ' + canon(CANON.posoennoisme) + ', los ' + canon(CANON.title) + ' constituyen el zócalo móvil del ' + canon(CANON.axis) + '. Estabilizan la transmisión, orientan los ritmos del conjunto, inyectan tensiones creadoras e inician el movimiento hacia las Herramientas posœnnoïales.</p>' +
        '<p>Su función pertenece a una lógica de referencias de oscilación: estables sin rigidez, respirantes sin dispersión. Cada uno articula un elemento, un tótem, un número-guía, un ideograma conceptual y una representación funcional.</p>' +
        '<p>' + canon(CANON.rezonans) + ' afina; ' + canon(CANON.peroptissimisme) + ' convierte la crisis en relanzamiento; ' + canon(CANON.illusion) + ' revela y desclava los filtros perceptivos; ' + canon(CANON.alioevolution) + ' transforma por la alteridad conservando el anclaje. Juntos dan al sistema su primera tenencia energética.</p>',
      h_pillars: 'Los cuatro pilares',
      h_features: 'Dinámicas operativas',
      features: [
        'Zócalo energético del Axis y referencia de oscilaciones del conjunto.',
        'Estabilizadores de transmisión e iniciadores del movimiento hacia las Herramientas posœnnoïales.',
        'Reguladores rítmicos y vectores oscilatorios del Organon posœnnoïal.',
        'Cada pilar articula su propio elemento, tótem y número-guía.',
        'Su interacción con los Engranajes alimenta la emergencia de las Modalidades operativas.'
      ],
      h_questions: 'Aplicaciones / referencias',
      questions: [
        '¿Qué pilar debe activarse para ajustar la situación presente?',
        '¿La tensión pertenece al afinamiento, al cruce de una crisis, a un filtro perceptivo o a una alteridad transformadora?',
        '¿Qué Herramienta posœnnoïal recibirá mejor el impulso del pilar activado?',
        '¿Qué elemento simbólico — Aire, Fuego, Agua, Tierra — ofrece aquí el régimen más justo?'
      ],
      example_title: 'Ej.',
      example: 'Una obra o una decisión puede requerir primero el afinamiento de ' + canon(CANON.rezonans) + ', luego el relanzamiento de ' + canon(CANON.peroptissimisme) + ', el trabajo develador de ' + canon(CANON.illusion) + ' y por fin la integración llevada por ' + canon(CANON.alioevolution) + ' para volverse plenamente operativa.',
      h_family: 'Vínculos sistémicos',
      family_1: '<p><strong>Con las Herramientas:</strong> los ' + canon(CANON.title) + ' dan la base energética sobre la cual ' + canon(CANON.addition) + ', ' + canon(CANON.superposition) + ', ' + canon(CANON.instantane) + ' y el ' + canon(CANON.sujet) + ' pueden desplegarse con coherencia.</p>',
      family_2: '<p><strong>Con los Engranajes y las Modalidades:</strong> los flujos ' + canon(CANON.posoennoiaque) + ' y ' + canon(CANON.posoennoique) + ' actúan sobre los ' + canon(CANON.title) + ', que entonces comparten su actividad con las Herramientas y alimentan la emergencia de las ' + canon(CANON.modalites) + '.</p>',
      h_wordbuild: 'Construcción / lógica del grupo',
      word_blocks: [
        { head: '1) Zócalo', text: 'Los Pilares sirven de base dinámica: sostienen la arquitectura sin inmovilizarla.' },
        { head: '2) Oscilación', text: 'Ofrecen referencias de oscilación que permiten al Organon respirar entre tensión, ajuste, develamiento y transformación.' },
        { head: '3) Cuadratura viva', text: 'Aire, Fuego, Agua y Tierra componen una distribución elemental en la que cada pilar guarda su singularidad mientras trabaja con los demás.' }
      ],
      word_notes: [
        'Función posœnnoïal: « Zócalo » — referencias de oscilación.',
        'Números-guía: 22 / 11 / 6 / 4.',
        'Elementos: Aire / Fuego / Agua / Tierra.',
        'Tótems: Libélula / Phoenix / Sirena / Árbol.'
      ],
      cta_translate: LABELS.ES.cta_translate
    }
  };

  var PILLARS = [
    {
      key: "rezonans",
      title: CANON.rezonans,
      link: URLS.rezonans,
      concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/ReZonans_2.png?v=1746212538",
      guide_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_22_copie.png?v=1748797221",
      element_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/air.png?v=1746209173",
      totem_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/libellule.png?v=1746172804",
      guide: { FR: "22", EN: "22", ES: "22" },
      element: { FR: "Air", EN: "Air", ES: "Aire" },
      totem: { FR: "Libellule", EN: "Dragonfly", ES: "Libélula" },
      desc: {
        FR: "Ajustement vibratoire de l’être en interaction avec l’environnement. Instrument d’accordage : repérer un écart, l’habiter, le moduler, jusqu’à une cohérence active.",
        EN: "Vibratory adjustment of the being in interaction with the environment. Tuning instrument: locate a gap, inhabit it, modulate it, until an active coherence emerges.",
        ES: "Ajuste vibratorio del ser en interacción con el entorno. Instrumento de afinación: reconocer un desfase, habitarlo, modularlo, hasta una coherencia activa."
      }
    },
    {
      key: "peroptissimisme",
      title: CANON.peroptissimisme,
      link: URLS.peroptissimisme,
      concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Peroptissimisme_2.png?v=1746212647",
      guide_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_11.png?v=1748802245",
      element_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/feu.png?v=1746730410",
      totem_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/phoenix.png?v=1746730325",
      guide: { FR: "11", EN: "11", ES: "11" },
      element: { FR: "Feu", EN: "Fire", ES: "Fuego" },
      totem: { FR: "Phoenix", EN: "Phoenix", ES: "Phoenix" },
      desc: {
        FR: "Tension féconde lucidité-relance. Convertit une crise en moteur de projet viable, avec cap, endurance et transmutation.",
        EN: "Fertile tension between lucidity and relaunch. Converts a crisis into the engine of a viable project, with direction, endurance and transmutation.",
        ES: "Tensión fecunda entre lucidez y relanzamiento. Convierte una crisis en motor de un proyecto viable, con rumbo, resistencia y transmutación."
      }
    },
    {
      key: "illusion",
      title: CANON.illusion,
      link: URLS.illusion,
      concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Illusion_2.png?v=1746212970",
      guide_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_6.png?v=1748810212",
      element_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/eau.png?v=1746734061",
      totem_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/sirene.png?v=1746733930",
      guide: { FR: "6", EN: "6", ES: "6" },
      element: { FR: "Eau", EN: "Water", ES: "Agua" },
      totem: { FR: "Sirène", EN: "Siren", ES: "Sirena" },
      desc: {
        FR: "Interface entre réel, imaginaire et perception vibratoire. Surface d’analyse des filtres : ce qui embellit, ce qui déforme, ce qui révèle, ce qui hypnotise.",
        EN: "Interface between the real, the imaginary and vibratory perception. Surface for analysing filters: what beautifies, what distorts, what reveals, what hypnotizes.",
        ES: "Interfaz entre lo real, lo imaginario y la percepción vibratoria. Superficie de análisis de los filtros: lo que embellece, lo que deforma, lo que revela, lo que hipnotiza."
      }
    },
    {
      key: "alioevolution",
      title: CANON.alioevolution,
      link: URLS.alioevolution,
      concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Alioevolution_2.png?v=1746212956",
      guide_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_4.png?v=1750053298",
      element_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/terre.png?v=1750053431",
      totem_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/arbre.png?v=1750053385",
      guide: { FR: "4", EN: "4", ES: "4" },
      element: { FR: "Terre", EN: "Earth", ES: "Tierra" },
      totem: { FR: "Arbre", EN: "Tree", ES: "Árbol" },
      desc: {
        FR: "Transformation enracinée dans l’altérité. Rend l’autre co-auteur du devenir : évolution réciproque, organique et située.",
        EN: "Transformation rooted in alterity. Makes the other a co-author of becoming: reciprocal, organic and situated evolution.",
        ES: "Transformación enraizada en la alteridad. Vuelve al otro coautor del devenir: evolución recíproca, orgánica y situada."
      }
    }
  ];

  function findSlot(root, slot){
    return root ? root.querySelector("[data-po-slot='" + slot + "']") : null;
  }

  function setText(root, slot, value){
    var el = findSlot(root, slot);
    if (el) el.textContent = clampStr(value);
  }

  function setHTML(root, slot, value){
    var el = findSlot(root, slot);
    if (el) el.innerHTML = clampStr(value);
  }

  function setImg(root, slot, src, alt){
    var el = findSlot(root, slot);
    if (!el) return;
    var media = el.closest(".po-axis-title__media, .po-axis-chip__media");
    if (src){
      el.setAttribute("src", clampStr(src));
      el.setAttribute("alt", clampStr(alt || ""));
      if (media && media.classList) media.classList.remove("is-hidden");
    } else {
      el.removeAttribute("src");
      el.setAttribute("alt", "");
      if (media && media.classList) media.classList.add("is-hidden");
    }
  }

  function renderList(root, slot, items){
    var el = findSlot(root, slot);
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.innerHTML = clampStr(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, blocks){
    var host = findSlot(root, "wordbuild_blocks");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(block){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      wrap.innerHTML =
        '<div class="po-axis-wb__h">' + clampStr(block.head) + '</div>' +
        '<div class="po-axis-wb__t">' + clampStr(block.text) + '</div>';
      host.appendChild(wrap);
    });
  }

  function renderCards(root, lang){
    var host = findSlot(root, "pillar_cards");
    if (!host) return;
    host.innerHTML = "";

    var labels = LABELS[lang];

    PILLARS.forEach(function(item){
      var article = document.createElement("article");
      article.className = "po-pillar-card";
      article.innerHTML =
        '<a class="po-pillar-card__title" href="' + clampStr(item.link) + '">' + canon(item.title) + '</a>' +
        '<div class="po-pillar-card__media" aria-hidden="true">' +
          '<img class="po-pillar-card__img" src="' + clampStr(item.concept) + '" alt="' + clampStr(item.title) + '" loading="lazy" decoding="async" />' +
        '</div>' +
        '<div class="po-pillar-card__badges">' +
          buildBadge(labels.guide, item.guide_img, labels.guide, item.guide[lang]) +
          buildBadge(labels.element, item.element_img, labels.element, item.element[lang]) +
          buildBadge(labels.totem, item.totem_img, labels.totem, item.totem[lang]) +
        '</div>' +
        '<p class="po-pillar-card__desc">' + clampStr(item.desc[lang]) + '</p>' +
        '<div class="po-pillar-card__linkline"><a href="' + clampStr(item.link) + '">' + clampStr(labels.see_page) + '</a></div>';
      host.appendChild(article);
    });
  }

  function markButtons(root, lang){
    root.querySelectorAll(".po-langbtn").forEach(function(btn){
      var isActive = btn.getAttribute("data-po-lang") === lang;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: ""
  };

  var AUDIO_UI = {
    FR: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    EN: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    ES: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  var AUDIO_GROUPS = [
    { key: "features", heading: "h_features", slots: ["features"] },
    { key: "questions", heading: "h_questions", slots: ["questions", "example_box"] },
    { key: "family", heading: "h_family", slots: ["family_1", "family_2"] },
    { key: "wordbuild", heading: "h_wordbuild", slots: ["wordbuild_blocks", "wordbuild_notes"] }
  ];

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR;
  }

  function getSpeechLangCode(lang){
    var L = normLang(lang);
    if (L === "EN") return "en-US";
    if (L === "ES") return "es-ES";
    return "fr-FR";
  }

  function getAudioRoots(){
    return document.querySelectorAll(ROOT_SEL);
  }

  function getDetailBlocks(root){
    return root ? root.querySelectorAll(".po-lex-details") : [];
  }

  function hasDetailBlocks(root){
    return !!(root && getDetailBlocks(root).length);
  }

  function ensureAudioStyles(){
    if (!document || document.getElementById("po-piliers-audio-style")) return;
    var style = document.createElement("style");
    style.id = "po-piliers-audio-style";
    style.textContent =
      ".po-axis-audio-wrap{margin:12px 0 14px;display:flex;justify-content:flex-start;}" +
      ".po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.03);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;font-weight:800;line-height:1.2;cursor:pointer;display:inline-flex;align-items:center;gap:8px;max-width:100%;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.05);}" +
      ".po-axis-audio-btn.is-playing{background:rgba(0,0,0,.08);}" +
      ".po-axis-audio-btn__icon{display:inline-block;min-width:1em;text-align:center;}" +
      ".po-axis-section[data-po-lex-id='piliers'] .po-lex-summary{display:flex;align-items:center;gap:10px;}" +
      ".po-axis-section[data-po-lex-id='piliers'] .po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}" +
      ".po-axis-section[data-po-lex-id='piliers'] .po-axis-audio-btn__label{white-space:normal;}" +
      ".po-axis-section[data-po-lex-id='piliers'] .po-axis-audio-anchor{display:flex;justify-content:flex-start;margin:12px 0 10px;}" +
      "@media (max-width:760px){.po-axis-section[data-po-lex-id='piliers'] .po-lex-summary{align-items:flex-start;}.po-axis-section[data-po-lex-id='piliers'] .po-lex-summary .po-axis-audio-btn{margin-left:0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role);

    var icon = document.createElement("span");
    icon.className = "po-axis-audio-btn__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = "⏵";

    var label = document.createElement("span");
    label.className = "po-axis-audio-btn__label";

    btn.appendChild(icon);
    btn.appendChild(label);
    return btn;
  }

  function ensureGeneralAudio(root){
    if (!root) return;
    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (generalWrap) return;

    generalWrap = document.createElement("div");
    generalWrap.className = "po-axis-audio-wrap";
    generalWrap.setAttribute("data-po-audio-role", "general");
    var btn = createAudioButton("general");
    btn.setAttribute("data-po-audio-key", "general");
    generalWrap.appendChild(btn);

    var axisTop = root.querySelector(".po-axis-top");
    var defShort = findSlot(root, "def_short");
    var firstDetail = root.querySelector(".po-lex-details");
    var panel = root.querySelector(".po-lex-panel");

    if (axisTop && axisTop.parentNode){
      if (axisTop.nextSibling) axisTop.parentNode.insertBefore(generalWrap, axisTop.nextSibling);
      else axisTop.parentNode.appendChild(generalWrap);
      return;
    }
    if (defShort && defShort.parentNode){
      defShort.parentNode.insertBefore(generalWrap, defShort);
      return;
    }
    if (firstDetail && firstDetail.parentNode){
      firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
      return;
    }
    if (panel) panel.insertBefore(generalWrap, panel.firstChild || null);
  }

  function ensureDetailAudio(root){
    if (!root) return;

    if (hasDetailBlocks(root)){
      var details = getDetailBlocks(root);
      for (var i = 0; i < details.length; i++){
        var summary = details[i].querySelector(".po-lex-summary");
        if (!summary) continue;
        var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
        if (!btn){
          btn = createAudioButton("detail");
          summary.appendChild(btn);
        }
        btn.setAttribute("data-po-audio-key", "detail:" + i);
        btn.setAttribute("data-po-audio-index", String(i));
      }
      return;
    }

    AUDIO_GROUPS.forEach(function(group){
      var heading = findSlot(root, group.heading);
      if (!heading || !heading.parentNode) return;

      var prev = heading.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains("po-axis-audio-anchor") && prev.getAttribute("data-po-audio-key") === ("group:" + group.key)) return;

      var wrap = document.createElement("div");
      wrap.className = "po-axis-audio-anchor";
      wrap.setAttribute("data-po-audio-key", "group:" + group.key);

      var btn = createAudioButton("group");
      btn.setAttribute("data-po-audio-key", "group:" + group.key);
      btn.setAttribute("data-po-audio-group", group.key);
      wrap.appendChild(btn);

      heading.parentNode.insertBefore(wrap, heading);
    });
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    ensureGeneralAudio(root);
    ensureDetailAudio(root);
  }

  function setButtonVisualState(btn, lang, isPlaying){
    if (!btn) return;
    var ui = audioUI(lang);
    var role = btn.getAttribute("data-po-audio-role") || "detail";
    var label = btn.querySelector(".po-axis-audio-btn__label");
    var icon = btn.querySelector(".po-axis-audio-btn__icon");

    if (btn.classList && btn.classList.toggle) btn.classList.toggle("is-playing", !!isPlaying);
    if (icon) icon.textContent = isPlaying ? "⏸" : "⏵";
    if (label) label.textContent = isPlaying ? ui.stop : (role === "general" ? ui.general : ui.block);
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : "";
    root.querySelectorAll(".po-axis-audio-btn").forEach(function(btn){
      setButtonVisualState(btn, lang, !!activeKey && btn.getAttribute("data-po-audio-key") === activeKey);
    });
  }

  function getTextValue(el){
    if (!el) return "";
    return clampStr(el.innerText || el.textContent || "").replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(host){
    if (!host || !host.querySelectorAll) return;
    host.querySelectorAll(".po-axis-audio-btn, .po-axis-audio-wrap, .po-axis-audio-anchor").forEach(function(node){
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function collectGeneralText(root){
    var parts = [];
    ["title", "kicker", "h_def", "def_short", "def_long", "h_pillars", "pillar_cards"].forEach(function(slot){
      var el = findSlot(root, slot);
      if (!el) return;
      var clone = el.cloneNode(true);
      removeAudioButtonsFromClone(clone);
      var txt = getTextValue(clone);
      if (txt) parts.push(txt);
    });
    return parts.join(". ");
  }

  function collectDetailText(root, index){
    var detail = getDetailBlocks(root)[index];
    if (!detail) return "";

    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);

    return parts.join(". ");
  }

  function collectGroupText(root, key){
    var config = null;
    for (var i = 0; i < AUDIO_GROUPS.length; i++){
      if (AUDIO_GROUPS[i].key === key){
        config = AUDIO_GROUPS[i];
        break;
      }
    }
    if (!config) return "";

    var parts = [];
    var headingTxt = getTextValue(findSlot(root, config.heading));
    if (headingTxt) parts.push(headingTxt);

    config.slots.forEach(function(slot){
      var el = findSlot(root, slot);
      if (!el) return;
      var clone = el.cloneNode(true);
      removeAudioButtonsFromClone(clone);
      var txt = getTextValue(clone);
      if (txt) parts.push(txt);
    });

    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = "";

    pieces.forEach(function(piece){
      piece = clampStr(piece).trim();
      if (!piece) return;
      var candidate = current ? (current + " " + piece) : piece;
      if (candidate.length > 220){
        if (current) out.push(current.trim());
        current = piece;
      } else {
        current = candidate;
      }
    });

    if (current) out.push(current.trim());
    return out;
  }

  function buildUnits(root, role, keyOrIndex){
    var units = [];
    var detailsCount = getDetailBlocks(root).length;

    if (role === "general"){
      units.push({ role: "general", key: "general" });
      if (detailsCount){
        for (var i = 0; i < detailsCount; i++) units.push({ role: "detail", key: "detail:" + i, index: i });
      } else {
        AUDIO_GROUPS.forEach(function(group){
          units.push({ role: "group", key: "group:" + group.key, groupKey: group.key });
        });
      }
      return units;
    }

    if (role === "detail"){
      var start = Math.max(0, parseInt(keyOrIndex, 10) || 0);
      for (var j = start; j < detailsCount; j++) units.push({ role: "detail", key: "detail:" + j, index: j });
      return units;
    }

    if (role === "group"){
      var startIdx = 0;
      for (var k = 0; k < AUDIO_GROUPS.length; k++){
        if (AUDIO_GROUPS[k].key === keyOrIndex){ startIdx = k; break; }
      }
      for (var m = startIdx; m < AUDIO_GROUPS.length; m++) units.push({ role: "group", key: "group:" + AUDIO_GROUPS[m].key, groupKey: AUDIO_GROUPS[m].key });
      return units;
    }

    return units;
  }

  function stopAudio(){
    try{
      if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel();
    }catch(e){}

    getAudioRoots().forEach(function(root){
      refreshAudioLabels(root, readLang());
    });

    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
  }

  function playCurrentUnit(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;

    if (PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = "";
    PO_AUDIO_STATE.activeKey = unit.key;

    if (unit.role === "general"){
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else if (unit.role === "detail"){
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail) detail.open = true;
      text = collectDetailText(PO_AUDIO_STATE.root, unit.index);
    } else if (unit.role === "group"){
      text = collectGroupText(PO_AUDIO_STATE.root, unit.groupKey);
    }

    refreshAudioLabels(PO_AUDIO_STATE.root, readLang());

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text);
    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit();
      return;
    }

    speakNextChunk();
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;

    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit();
      return;
    }

    var chunk = PO_AUDIO_STATE.chunks.shift();
    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(readLang());
    utter.rate = 0.95;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };

    try{
      PO_AUDIO_SYNTH.speak(utter);
    }catch(e){
      speakNextChunk();
    }
  }

  function startAudio(root, role, keyOrIndex){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, keyOrIndex);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";

    playCurrentUnit();
  }

  function bindAudioButtons(root){
    if (!root) return;
    root.querySelectorAll(".po-axis-audio-btn").forEach(function(btn){
      if (btn.__poAudioBound) return;

      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        var role = this.getAttribute("data-po-audio-role") || "detail";
        var key = this.getAttribute("data-po-audio-key") || "";
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);

        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
          stopAudio();
          return;
        }

        if (role === "general"){
          startAudio(root, "general", "general");
        } else if (role === "detail"){
          startAudio(root, "detail", parseInt(this.getAttribute("data-po-audio-index"), 10));
        } else {
          startAudio(root, "group", this.getAttribute("data-po-audio-group") || "features");
        }
      });

      btn.__poAudioBound = true;
    });
  }

  function initAudioEverywhere(lang){
    getAudioRoots().forEach(function(root){
      ensureAudioButtons(root);
      bindAudioButtons(root);
      refreshAudioLabels(root, normLang(lang || readLang()));
    });
  }

  function protectBlock(root){
    if (!root) return;
    root.classList.add("notranslate");
    root.setAttribute("translate", "no");
    var scope = root.querySelector(".po-lex-scope");
    if (scope){
      scope.classList.add("notranslate");
      scope.setAttribute("translate", "no");
    }
  }

  function renderBlock(root, lang){
    var t = DATA[lang];
    var labels = LABELS[lang];

    setImg(root, "title_img", URLS.title, t.title);
    setText(root, "title", t.title);
    setHTML(root, "kicker", t.kicker);

    setText(root, "h_def", t.h_def);
    setText(root, "h_pillars", t.h_pillars);
    setText(root, "h_features", t.h_features);
    setText(root, "h_questions", t.h_questions);
    setText(root, "h_family", t.h_family);
    setText(root, "h_wordbuild", t.h_wordbuild);

    setText(root, "hint_fold", labels.open);
    setText(root, "hint_fold2", labels.open);
    setText(root, "hint_fold3", labels.open);

    setHTML(root, "def_short", t.def_short);
    setHTML(root, "def_long", t.def_long);

    renderCards(root, lang);
    renderList(root, "features", t.features);
    renderList(root, "questions", t.questions);
    setHTML(root, "example_box", '<div><strong>' + clampStr(t.example_title) + '</strong> ' + clampStr(t.example) + '</div>');
    setHTML(root, "family_1", t.family_1);
    setHTML(root, "family_2", t.family_2);
    renderWordBlocks(root, t.word_blocks);
    renderList(root, "wordbuild_notes", t.word_notes);
    setText(root, "cta_translate", t.cta_translate);

    markButtons(root, lang);
  }

  function applyLang(lang){
    var L = storeLang(lang);
    stopAudio();

    document.querySelectorAll(ROOT_SEL).forEach(function(root){
      protectBlock(root);
      renderBlock(root, L);
    });

    initAudioEverywhere(L);

    try{
      window.dispatchEvent(new CustomEvent("po:locale-changed", { detail: { lang: L } }));
    }catch(e){
      try{ window.dispatchEvent(new Event("po:locale-changed")); }catch(_e){}
    }
  }

  function bindButtons(root){
    if (!root) return;
    root.querySelectorAll(".po-langbtn").forEach(function(btn){
      if (btn.__poLangBound) return;
      btn.addEventListener("click", function(){
        applyLang(btn.getAttribute("data-po-lang"));
      });
      btn.__poLangBound = true;
    });
  }

  function init(){
    var roots = document.querySelectorAll(ROOT_SEL);
    if (!roots.length) return;

    roots.forEach(function(root){
      protectBlock(root);
      bindButtons(root);
    });

    applyLang(readLang());
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoPiliersTrilangProtected20260401 = {
    init: init,
    setLang: applyLang,
    getLang: readLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
